"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParentBindingConstraintsWithTag = isParentBindingConstraintsWithTag;
const isBindingConstraintsWithTag_1 = require("./isBindingConstraintsWithTag");
const isParentBindingConstraints_1 = require("./isParentBindingConstraints");
function isParentBindingConstraintsWithTag(tag, value) {
    return (0, isParentBindingConstraints_1.isParentBindingConstraints)((0, isBindingConstraintsWithTag_1.isBindingConstraintsWithTag)(tag, value));
}
//# sourceMappingURL=isParentBindingConstraintsWithTag.js.map